import alfaRomeo from "@/assets/brands/alfa-romeo.avif.asset.json";
import audi from "@/assets/brands/audi.avif.asset.json";
import bmw from "@/assets/brands/bmw.avif.asset.json";
import citroen from "@/assets/brands/citroen.avif.asset.json";
import fiat from "@/assets/brands/fiat.avif.asset.json";
import ford from "@/assets/brands/ford.avif.asset.json";
import hondaLogo from "@/assets/brands/honda-logo.png";
import jeep from "@/assets/brands/jeep.avif.asset.json";
import kia from "@/assets/brands/kia.avif.asset.json";
import lancia from "@/assets/brands/lancia.avif.asset.json";
import landRover from "@/assets/brands/land-rover.avif.asset.json";
import mazda from "@/assets/brands/mazda.avif.asset.json";
import mercedes from "@/assets/brands/mercedes.avif.asset.json";
import mini from "@/assets/brands/mini.avif.asset.json";
import mitsubishi from "@/assets/brands/mitsubishi.avif.asset.json";
import nissan from "@/assets/brands/nissan.avif.asset.json";
import opel from "@/assets/brands/opel.avif.asset.json";
import peugeot from "@/assets/brands/peugeot.avif.asset.json";
import porsche from "@/assets/brands/porsche.avif.asset.json";
import renault from "@/assets/brands/renault.webp.asset.json";
import seat from "@/assets/brands/seat.avif.asset.json";
import skoda from "@/assets/brands/skoda.avif.asset.json";
import subaru from "@/assets/brands/subaru.avif.asset.json";
import toyota from "@/assets/brands/toyota.avif.asset.json";
import volkswagen from "@/assets/brands/volkswagen.avif.asset.json";
import volvo from "@/assets/brands/volvo.avif.asset.json";
import yamaha from "@/assets/brands/yamaha.avif.asset.json";

type Brand = { name: string; logo: string };

// Add more brands here — the grid expands automatically.
export const BRANDS: Brand[] = [
  { name: "Alfa Romeo", logo: alfaRomeo.url },
  { name: "Audi", logo: audi.url },
  { name: "BMW", logo: bmw.url },
  { name: "Citroën", logo: citroen.url },
  { name: "Fiat", logo: fiat.url },
  { name: "Ford", logo: ford.url },
  { name: "Honda", logo: hondaLogo },
  { name: "Jeep", logo: jeep.url },
  { name: "Kia", logo: kia.url },
  { name: "Lancia", logo: lancia.url },
  { name: "Land Rover", logo: landRover.url },
  { name: "Mazda", logo: mazda.url },
  { name: "Mercedes-Benz", logo: mercedes.url },
  { name: "Mini", logo: mini.url },
  { name: "Mitsubishi", logo: mitsubishi.url },
  { name: "Nissan", logo: nissan.url },
  { name: "Opel", logo: opel.url },
  { name: "Peugeot", logo: peugeot.url },
  { name: "Porsche", logo: porsche.url },
  { name: "Renault", logo: renault.url },
  { name: "Seat", logo: seat.url },
  { name: "Škoda", logo: skoda.url },
  { name: "Subaru", logo: subaru.url },
  { name: "Toyota", logo: toyota.url },
  { name: "Volkswagen", logo: volkswagen.url },
  { name: "Volvo", logo: volvo.url },
  { name: "Yamaha", logo: yamaha.url },
];

export function BrandsStrip() {
  return (
    <section id="brands" className="border-y border-border bg-secondary/30 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="mb-8 flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
          <div>
            <p className="mb-2 text-xs font-bold uppercase tracking-widest text-royal">All marques</p>
            <h2 className="text-3xl font-black text-ink sm:text-4xl">Shop by brand</h2>
            <p className="mt-2 max-w-xl text-sm text-muted-foreground">
              Parts curated for 30+ European and global marques. Tap a logo to browse what we have in stock.
            </p>
          </div>
          <a
            href="/shop"
            className="press inline-flex h-10 items-center gap-1.5 rounded-xl border border-border bg-background px-4 text-xs font-bold text-ink transition-colors hover:bg-ink hover:text-paper"
          >
            View full catalogue
          </a>
        </div>

        <ul
          role="list"
          className="grid grid-cols-4 gap-2.5 sm:grid-cols-6 sm:gap-3 md:grid-cols-8 lg:grid-cols-10"
        >
          {BRANDS.map((b) => (
            <li key={b.name}>
              <a
                href={b.name === "Renault" ? "/shop?brand=renault" : `/shop?q=${encodeURIComponent(b.name)}`}
                title={b.name}
                aria-label={`Shop ${b.name} parts`}
                className="group relative flex aspect-square flex-col items-center justify-center overflow-hidden rounded-xl border border-border bg-background px-2 py-2.5 transition-all duration-200 hover:-translate-y-0.5 hover:border-royal/40 hover:shadow-md"
              >
                <img
                  src={b.logo}
                  alt={`${b.name} logo`}
                  loading="lazy"
                  decoding="async"
                  width={56}
                  height={56}
                  className="h-10 w-10 object-contain opacity-70 grayscale transition-all duration-200 group-hover:-translate-y-2 group-hover:opacity-100 group-hover:grayscale-0 sm:h-12 sm:w-12"
                />
                <span className="pointer-events-none absolute inset-x-1 bottom-1.5 truncate text-center text-[10px] font-semibold uppercase tracking-wider text-royal opacity-0 transition-all duration-200 group-hover:opacity-100">
                  {b.name}
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}